export default __webpack_public_path__ + "static/media/calendar.3df9e23d.svg";